// This file renders the component to let user know about his profile being updated in his previous login and re-logged in.
import { ThemeProvider } from "@mui/material";
import { ProfileUpdateLocalStorageItems } from "@src/appV2/redesign/Profile/constants";
import {
  ProfileUpdateBottomSheet,
  type ProfileUpdateType,
} from "@src/appV2/redesign/Profile/ProfileUpdateBottomSheet";
import { useModalState } from "@src/appV2/redesign/system/ui-components";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { ActionType } from "@store/session";
import { Store } from "@store/store.model";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

function ProfileUpdatePopup() {
  const popups = useSelector((state: Store) => state?.session?.popups);
  const { isAuthorized } = useSelector((state: Store) => state?.session);
  const { visible, updateType } = popups?.profileUpdatePopup ?? {};
  const dispatch = useDispatch();
  const modalState = useModalState();

  const onClose = useCallback(() => {
    dispatch({ type: ActionType.HIDE_PROFILE_UPDATE_POPUP });
    modalState.closeModal();
  }, [dispatch, modalState]);

  const resetShowProfilePopupLocalStorage = useCallback(() => {
    localStorage.setItem(ProfileUpdateLocalStorageItems.UPDATE_PROFILE_EMAIL_CHANGED, "");
    localStorage.setItem(ProfileUpdateLocalStorageItems.UPDATE_PROFILE_PHONE_NUMBER_CHANGED, "");
  }, []);

  useEffect(() => {
    if (isAuthorized) {
      if (localStorage.getItem(ProfileUpdateLocalStorageItems.UPDATE_PROFILE_EMAIL_CHANGED)) {
        dispatch({
          type: ActionType.SHOW_PROFILE_UPDATE_POPUP,
          data: { updateType: "EMAIL" },
        });
        resetShowProfilePopupLocalStorage();
      } else if (
        localStorage.getItem(ProfileUpdateLocalStorageItems.UPDATE_PROFILE_PHONE_NUMBER_CHANGED)
      ) {
        dispatch({
          type: ActionType.SHOW_PROFILE_UPDATE_POPUP,
          data: { updateType: "PHONE" },
        });
        resetShowProfilePopupLocalStorage();
      }
    }
  }, [isAuthorized, resetShowProfilePopupLocalStorage, dispatch]);

  // Sync Redux state with modal state
  useEffect(() => {
    if (visible && updateType) {
      modalState.openModal();
    }
  }, [visible, updateType, modalState]);

  if (!visible || !updateType) {
    return null;
  }

  return (
    <ThemeProvider theme={getTheme()}>
      <ProfileUpdateBottomSheet
        modalState={modalState}
        updateType={updateType as ProfileUpdateType}
        onClose={onClose}
      />
    </ThemeProvider>
  );
}

export { ProfileUpdatePopup };
